var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"world-map"},[_c('div',{staticClass:"intro"},[_vm._v("为您打开酒世界")]),_c('div',{staticClass:"intro-split"}),_c('ECharts',{attrs:{"options":_vm.options},on:{"click":_vm.onClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }